import posthog from 'posthog-js';

const POSTHOG_KEY = 'phc_rXGzP6smPYobkfBMceFTw5sjEpsRbhdGsEWmWvcEhWth';
const POSTHOG_HOST = 'https://us.i.posthog.com';

export const initPostHog = () => {
  if (typeof window !== 'undefined') {
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      person_profiles: 'identified_only',

      // Autocapture — clicks, inputs, form submissions
      autocapture: true,

      // Page views & navigation
      capture_pageview: true,
      capture_pageleave: true,

      // Session recording
      disable_session_recording: false,

      // Performance & web vitals
      capture_performance: true,

      // Error tracking
      capture_exceptions: true,

      // Track dead clicks (user clicks something with no response)
      capture_dead_clicks: true,

      // Heatmaps
      capture_heatmaps: true,

      // Re-identify returning users from localStorage
      loaded: (ph) => {
        const userRaw = localStorage.getItem('user-health');
        if (userRaw) {
          try {
            const user = JSON.parse(userRaw);
            if (user?.id) {
              ph.identify(user.id, {
                email: user.email,
                name: `${user.firstname} ${user.lastname}`,
                username: user.username,
                role: user.role,
                companyId: user.companyId,
              });
            }
          } catch (e) {
            // ignore parse errors
          }
        }
      },
    });

    // Global error handler — captures unhandled errors as events
    window.addEventListener('error', (event) => {
      posthog.capture('$exception', {
        $exception_message: event.message,
        $exception_source: event.filename,
        $exception_lineno: event.lineno,
        $exception_colno: event.colno,
        $exception_stack: event.error?.stack,
      });
    });

    // Unhandled promise rejections
    window.addEventListener('unhandledrejection', (event) => {
      posthog.capture('$exception', {
        $exception_message: event.reason?.message || String(event.reason),
        $exception_stack: event.reason?.stack,
        $exception_type: 'unhandled_promise_rejection',
      });
    });
  }
  return posthog;
};

export default posthog;
